const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';

//Import Designs
import { Typography, Grid2 } from '@mui/material';
import ReactHtmlParser from 'react-html-parser';


class RulesContestant extends Component {
    constructor(props) {
        super(props);
        this.state = { anchorEl: '', open: '' };
    }

    decodeHTMLEntities(text) {
        var entities = [
            ['amp', '&'],
            ['apos', '\''],
            ['#x27', '\''],
            ['#x2F', '/'],
            ['#39', '\''],
            ['#47', '/'],
            ['lt', '<'],
            ['gt', '>'],
            ['nbsp', ' '],
            ['quot', '"']
        ];
        for (var i = 0, max = entities.length; i < max; ++i)
            text = text.replace(new RegExp('&' + entities[i][0] + ';', 'g'), entities[i][1]);
        return text;
    }

    render() {
        const rules = (typeof this.props.short !== "undefined") ? this.props.short.allcatoption.contest_rules : null;
        if (rules != null) {
            //const rules_decoded = decode(rules);
            return (
                <Grid2 container className="wpvc_rules_content" >
                    <Typography component="div">{ReactHtmlParser(this.decodeHTMLEntities(rules))}</Typography>
                </Grid2>
            )
        } else {
            return ''
        }
    }
}

export default connect()(withTranslation("translations")(RulesContestant));
